import { EuiSpacer } from '@elastic/eui';
import APIv2Box from 'components/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/PrimaryBox';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import ASTable from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/asTable';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  APIv2Box,
  SuccessBox,
  PermissionBox,
  ASTable,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};